import React from 'react'
import { Grid } from '@material-ui/core'
import { Field } from 'react-final-form'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import FormTextFieldInline from '../../../components/fields/FormTextFieldInline'

const useStyles = makeStyles(
	(theme) => (
		{
			promoCodeStyle: {
				...styles(theme).text3,
				marginTop: 10
			}
		}
	)
)

interface PromoCodeProps {
	name: string
}

const PromoCode: React.FC<PromoCodeProps> = (
	{
		name
	}
) => {
	const classes = useStyles()

	return (
		<Grid container item xs={12}>
			<Grid container item xs={12} md={4}>
				<Field
					name={name}
					component={FormTextFieldInline}
					rectangle
					placeholder={{
						id: 'changementAppartement.formulaire.promoCode.placeholder',
						defaultMessage: 'Code privilège',
						description: 'Promotion code label'
					}}
					maxLength={15}
				/>
			</Grid>

			<Grid container item xs={12}>
				<span className={classes.promoCodeStyle}>
					<FormattedMessage
						id="changementAppartement.formulaire.promoCode.description"
						defaultMessage="Le code privilège sera pris en compte lors de la validation de votre dossier"
						description="Promotion code description"
					/>
				</span>
			</Grid>
		</Grid>
	)
}

export default PromoCode
